var render = function (_h,_vm) {var _c=_vm._c;return _c('router-view')}
var staticRenderFns = []

export { render, staticRenderFns }